Mmg.addShortcode(

  /**
   * @param {string} shortcodeName The name of the shortcode
   * @param {string} selector The selector used to locate this shortcode in the DOM
   * @param {callable} callback The callback function applied to every element matching the selector
   */
  'key_metrics',
  '.sc-key-metrics',

  /**
   *
   * Shortcode callback
   *
   * The shortcode callback receives the following parameters:
   *
   * @param {Element} el The shortcode's DOM element
   * @param {object} model The data model passed to the shortcode instance in data-json attribute
   * @param {jQuery} $ The callback function applied to every element matching the selector
   * @param {string} selector The shortcode selector that was passed to addShortcode
   * @param {string} className The name of the shortcode class
   */
  (el, model, $, selector, className) => {

    // Widget Declarations
    const $this = $(el);
    const modalTriggerSelector = `${selector}__modal-trigger`;
    const $content = $(`${selector}__modal-content`);

    /**
     * Initialize the widget
     */
    (function init(){
      addEvents();
    })();

    /**
     * Handle UI events
     */
    function addEvents() {
      $this.on('vclick', modalTriggerSelector, handleModalButtonClicks);
    }

    /**
     * Get the content and render the modal
     */
    function handleModalButtonClicks() {
      Mmg.Modal.show('Learn more about housing market data', $content.html());

      // Track modal impression for Key Metrics info modal
      if (typeof window.MOVEAnalytics !== 'undefined') {
        MOVEAnalytics.trackEvent('modalImpression', {
          modalName: 'local:landing:key_metrics:info',
          modalTrigger: 'local:landing:key_metrics:learn_more'
        });
      }
    }
  }
);
